import { createTheme } from '@mui/material/styles';

// Bridge2AI primary brand color
const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: '#8b59bd',
      light: '#f2edf8',
      dark: '#420B74',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#B77700', // Darkened for contrast (~7:1 on white)
      light: '#F2C566',
      dark: '#7A4F00',
      contrastText: '#000000',
    },
    text: {
      primary: '#000000',
      secondary: '#444444',
    },
    action: {
      selectedOpacity: 0.5
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '2rem',
          width: '100%',
          fontWeight: 500,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(30, 17, 105, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '1rem'
        },
      },
    }
  },
});

export default theme;
